import { createSlice } from "@reduxjs/toolkit";

const bookingSliceTakeOrder = createSlice({
  name: "SelectedCustomer",
  initialState: {},
  reducers: {
    setBookingToRedux: (state, action) => {
      return { ...state, ...action.payload };
    },

    resetBookingToRedux: (state) => {
       state = {};
       return state;
    },
  },
});

export const { setBookingToRedux, resetBookingToRedux } = bookingSliceTakeOrder.actions;

export default bookingSliceTakeOrder.reducer;